module.exports = __webpack_public_path__ + "img/default-avatar.e51de215.png";